<template>
  <SrpModal v-model:isVisible="_isVisible" size="medium">
    <template #content>
      <!-- Edit Title and Comment form -->
      <div class="edit-title-and-comment-form">
        <div class="standard-page-header standard-page-header--small-bottom-padding edit-title-and-comment-form__header">
          <h1 class="global-h1 standard-page-header__title">Edit section Title and Comment</h1>
        </div>

        <!-- Title and form element -->
        <div class="title-and-form-element edit-title-and-comment-form__title-and-form-element">
          <h4 class="global-h4 title-and-form-element__title">Title</h4>
          <input class="global-text-input title-and-form-element__form-element" type="text" style="max-width: 390px" v-model="_title" :disabled="isSaving" />
        </div>
        <!-- / Title and form element -->

        <!-- Title and form element -->
        <div class="title-and-form-element edit-title-and-comment-form__title-and-form-element">
          <h4 class="global-h4 title-and-form-element__title">Comment</h4>
          <textarea class="global-textarea title-and-form-element__form-element" style="height: 110px; min-height: 110px" v-model="_comment" :disabled="isSaving" />
        </div>
        <!-- / Title and form element -->
      </div>
      <!-- / Edit Title and Comment form -->
    </template>

    <template #footer="{ closeModal }">
      <SrpButton color="gray" fill="outlined" style="margin-right: 12px" @click="closeModal" :isDisabled="isSaving">Cancel</SrpButton>

      <SrpButton
        @click="
          async () => {
            await save();
            closeModal();
          }
        "
        :isDisabled="isSaving"
      >
        <template #icon>
          <LoadingIcon v-if="isSaving" :size="22" />
          <IconEmbedded v-else name="save_2" :size="22" color="rgba(255, 255, 255, 0.4)" />
        </template>
        Save
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import PhotoGalleryV2Repo from "@repos/PhotoGalleryV2Repo";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

const props = withDefaults(
  defineProps<{
    title: string;
    comment: string | null;
    customerId: string;
    photoGalleryId: string;
  }>(),
  {
    title: "",
    comment: null,
    customerId: "",
    photoGalleryId: "",
  }
);

const emit = defineEmits<{
  (e: "save", title: string, comment: string): void;
}>();

// Private isVisible ==========================================================
const _isVisible = ref<boolean>(false);

// Title and comment ==========================================================
const _title = ref<string>("");
const _comment = ref<string>("");

onMounted(() => {
  _title.value = props.title;
  _comment.value = props.comment || "";
});

// Save =======================================================================
const isSaving = ref<boolean>(false);

async function save() {
  isSaving.value = true;

  await PhotoGalleryV2Repo.updateMyUploadsGroupCommentAndTitle(props.customerId, props.photoGalleryId, _title.value, _comment.value);

  isSaving.value = false;

  emit("save", _title.value, _comment.value);
}
</script>

<style scoped lang="scss">
// Title and form element =====================================================
.title-and-form-element {
  &__title {
    margin-bottom: 7px;
  }

  &__form-element {
  }
}

// Edit Title and Comment form ================================================
.edit-title-and-comment-form {
  &__header {
    margin-bottom: 18px;
  }

  &__form-itself {
  }

  &__title-and-form-element {
    margin-bottom: 28px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
